import React from 'react';
import { useTheme } from 'react-native-paper';
import { InfoBox } from '..';
import { Text } from "../text/text";
import { translate } from '../../i18n/translate';
import { ThemeType } from '../../theme/theme';
import { InfoBoxType } from "../../enums";

export const BalanceDueUnavailableInfoBox = ({ style }: any) => {
  const theme = useTheme() as ThemeType;
  const { colors } = theme;
  return (
    <InfoBox 
      infoBoxType={InfoBoxType.ORANGE}
      headline={translate("authStack.balanceDueTemporarilyUnavailable")}
      style={style}
    >
      <Text tx="authStack.balanceDueTryWaiting" />
    </InfoBox>
  );
}